var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("action",null,{"clickHandler":_vm.clickHandler,"loading":_vm.loading})],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }